import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import {Link, useParams} from "react-router-dom";
import styled from "styled-components";
import { getAboutUsParagraph } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import CustomTable from "../../Common/DataTable/DataTable";

export default function ParagraphView() {
  const { id, partnerId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [paragraphData, setParagraphData] = useState({});
  
  const fetchTitle = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return
    };
    try {
      const response = await getAboutUsParagraph(id);
      console.log(response.data);
      const paragraphData = response.data.data[0]
      setParagraphData({...paragraphData,...paragraphData,index:response.data.data.indexOf(paragraphData)});
    } catch (error) {
      console.error(error);
    }finally {
      setIsLoading(false); // Stop spinner
    }
  };

  const columns = ["Part Name", "Content"];
  const rows = [];
  if (paragraphData && Object.keys(paragraphData).length > 0) {
    rows.push(["Header Paragraph", paragraphData.paragraph]);
  }
  useEffect(() => {
    fetchTitle();
  }, [id]);

  return (
    <>
    {isLoading ? <CmsCircularProgress/> : 
    <ContentWrapper>
      {/* Title */}
      <HomeTitle>Header Paragraph Section</HomeTitle>
      {/* Table */}
      <CustomTable
        columns={columns}
        rows={rows}
        isLoading={isLoading}
      />
      {/* Button section */}
      <ButtonWrapper>
        <Link
          to={`/${partnerId}/aboutus`}
        >
          <Button variant="secondary">Go Back</Button>
        </Link>
        <Link
          to={`/${partnerId}/aboutus/paragraph/edit/${id}`}
        >
          <Button>{Number(id) ? 'Edit' : 'Add'} Paragraph Section</Button>
        </Link>
      </ButtonWrapper>
    </ContentWrapper>}
    </>
  );
}

const ContentWrapper = styled.div`
  @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;


const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 2rem;
  justify-content: center;
   @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
  gap: 1rem;
}
`;
